
import React, { useState, useCallback } from 'react'
import { Grid, Message, Button } from 'semantic-ui-react'
import DropDown from '@commonComponents/formComponents/CustomDropDown'
import { useTranslation } from '@hooks/useTranslation'
import MassUpdateValue from './massUpdateValue'
import { MU_OPTIONS } from './constants'
import { useUpdateEffect } from '@hooks/useUpdateEffect'
import MUInvoiceList from './list/MUInvoiceList'
import { useSelector, useDispatch } from 'react-redux'
import { CustomLoader } from '@commonComponents/formComponents/loader'
import MUMerchList from './list/MUMerchList'
import { showToast } from '@commonComponents/showToast'
import { saveMassUpdateData } from '../../../../src/commonApis/saveEvents'

const eventType = 'UPDATE_ALL_ITEMS_EU'

const MassUpdate = (props) => {
    const {
        countryCode,
        fieldNameList,
        updateInvoiceHeader,
        updateMerchandiseItem,
        massUpdateAtInvoiceLevel,
        massUpdateAtMultiInvoiceLevel,
        isMassUpdateDisabled=false
    } = props

    const [fieldName, setFieldName] = useState({})
    const [fieldValue, setFieldValue] = useState('')
    const [massUpdateValue, setMassUpdateValue] = useState('')
    const [invoiceValues, setInvoiceValues] = useState({})
    const [isLoading, setLoader] = useState(false)
    const translate = useTranslation()
    const dispatch = useDispatch()

    const onDropDownChange = useCallback(
        (e, { value, name }) => {
            if (name == 'fieldName') {
                const data = fieldNameList.find((itm) => itm?.value === value)
                setFieldName(data)
            }
            if (name == 'invoiceValues') {
                const invData = invoiceDataList?.find(itm => itm?.value === value)
                setInvoiceValues(invData)
            }
            if (name == 'massUpdateValue') { setMassUpdateValue(value) }
        }, []
    )

    const invoiceDataList = useSelector(state => {
        return state.invoiceReducer.invoice.invoiceIdList.map((invoiceId, idx) => {
            const invoiceHeader = state.invoiceReducer.invoice.invoiceMap[invoiceId]?.invoiceHeader
            return {
                id: invoiceId,
                text: invoiceHeader?.invoiceNumber || `NA`,
                text_nl: invoiceHeader?.invoiceNumber || `NA`,
                text_es: invoiceHeader?.invoiceNumber || `NA`,
                value: `00${idx + 1}`,
                title: `INVOICE-00${idx + 1}`,
                checked: invoiceHeader?.checked || false
            }
        })
    }) || []

    const merchDataList = useSelector(state => {
        return state.invoiceReducer.invoice.invoiceMap[invoiceValues?.id]?.merchandiseIdList?.map((merchandiseId, idx) => {
            const merchandise = state.invoiceReducer.invoice.merchandiseMap[merchandiseId]
            return {
                id: merchandiseId,
                title: `LINE-ITEM-00${idx + 1}`,
                checked: merchandise?.checked || false
            }
        })
    }) || []

    useUpdateEffect(() => {
        setFieldValue('')
    }, [fieldName])

    useUpdateEffect(() => {
        setMassUpdateValue('')
    }, [fieldValue])

    useUpdateEffect(() => {
        if (massUpdateValue == '1')
            setInvoiceValues([])
        else
            setInvoiceValues({})
    }, [massUpdateValue])


    const applyMassUpdate = async () => {
        setLoader(true)
        let lineItemPayload = {}
        if (fieldName?.level === 'merchandise')
            lineItemPayload = { [`${fieldName?.key}`]: fieldValue }
        else if (fieldName?.level === 'mdocument')
            lineItemPayload = { [fieldName?.mdocumentName]: [{ [`${fieldName?.key}`]: fieldValue }] }

        if (massUpdateValue == '1') {
            const invoiceIds = invoiceDataList?.filter((invoice) => invoice.checked).map((invoice) => invoice?.id)
            const response = await saveMassUpdateData(eventType,
                { invoiceIDs: invoiceIds, lineItem: lineItemPayload, countryCode: countryCode }
            )
            if (response?.data?.eventMessage?.responseCode == '200') {
                if (fieldName?.level === 'merchandise') {
                    dispatch(massUpdateAtMultiInvoiceLevel(
                        { invoiceIds: invoiceIds, data: lineItemPayload }
                    ))
                } else if (fieldName?.level === 'mdocument') {
                    dispatch({
                        type:'invoiceReducer/massUpdateMerchDocsAtMultiInvoiceLevel',
                        payload: { 
                            invoiceIds: invoiceIds,
                            meta:{tableName:fieldName?.mdocumentName}, 
                            data: { [`${fieldName?.key}`]: fieldValue } 
                        }
                    })
                }

            } else showToast(translate('SOMETHING_WENT_WRONG'))
        }
        if (massUpdateValue == '2') {
            const invoiceIds = invoiceDataList?.map((invoice) => invoice?.id)
            const response = await saveMassUpdateData(eventType,
                { lineItem: lineItemPayload, countryCode: countryCode }
            )
            if (response?.data?.eventMessage?.responseCode == '200') {
                if (fieldName?.level === 'merchandise') {
                    dispatch(massUpdateAtMultiInvoiceLevel(
                        { invoiceIds: invoiceIds, data: lineItemPayload }
                    ))
                } else if (fieldName?.level === 'mdocument') {
                    dispatch({
                        type:'invoiceReducer/massUpdateMerchDocsAtMultiInvoiceLevel',
                        payload: { 
                            invoiceIds: invoiceIds,
                            meta:{tableName:fieldName?.mdocumentName}, 
                            data: { [`${fieldName?.key}`]: fieldValue } 
                        }
                    })
                }
            } else {showToast(translate('SOMETHING_WENT_WRONG'))}
        }
        if (massUpdateValue == '3') {
            const merchandiseIds = merchDataList?.filter((merch) => merch.checked).map((merch) => merch?.id)
            const response = await saveMassUpdateData(eventType,
                { merchandiseIDs: merchandiseIds, lineItem: lineItemPayload, countryCode: countryCode }
            )
            if (response?.data?.eventMessage?.responseCode == '200') {
                if (fieldName?.level === 'merchandise') {
                    dispatch(massUpdateAtInvoiceLevel(
                        { merchandiseIds: merchandiseIds, data: lineItemPayload }
                    ))
                } else if (fieldName?.level === 'mdocument') {
                    dispatch({
                        type:'invoiceReducer/massUpdateMerchDocsAtInvoiceLevel',
                        payload: { 
                            merchandiseIds: merchandiseIds,
                            meta:{tableName:fieldName?.mdocumentName}, 
                            data: { [`${fieldName?.key}`]: fieldValue } 
                        }
                    })
                }

            } else showToast('SOMETHING WENT WRONG!!')
        }
        setLoader(false)
    }

    const displayApplyButton = (massUpdateValue == '2')
        || (massUpdateValue == '1' && invoiceDataList?.some((invoice) => invoice.checked))
        || (massUpdateValue == '3' && merchDataList?.some((merch) => merch.checked))

    return (
        <Message>
            <div style={{ display: 'flex' }}>
                <div>{translate('MASS_UPDATE')}</div>
                <div style={{ marginLeft: 'auto' }}>
                    {(massUpdateValue == '1') && (
                        <>
                            <span>{translate("INVOICES")} : </span>
                            {invoiceDataList?.map((invoice, idx) => invoice.checked ? <span>00{idx + 1}, </span> : '')}
                        </>
                    )}
                    {(massUpdateValue == '3' && invoiceValues?.id) && (
                        <>
                            <span>{translate("LINE_ITEMS")} : </span>
                            {merchDataList?.map((merch, idx) => merch.checked ? <span>00{idx + 1}, </span> : '')}
                        </>
                    )}
                </div>
            </div>
            {isLoading && <CustomLoader />}
            <Grid className='responsiveGridCss'>
                <Grid.Row>
                    <Grid.Column>
                        <DropDown
                            id={`fieldName`}
                            label='FIELD'
                            className='field-bg dropdown100'
                            labelClass='text-none'
                            isLabel={true}
                            data={fieldNameList}
                            clearable
                            value={fieldName?.value}
                            name='fieldName'
                            onChange={onDropDownChange}
                            isDisabled={isMassUpdateDisabled||null}
                        />
                    </Grid.Column>
                    {fieldName?.value && (
                        <Grid.Column>
                            <MassUpdateValue
                                translate={translate}
                                countryCode={countryCode}
                                fieldName={fieldName}
                                fieldValue={fieldValue}
                                setFieldValue={setFieldValue}
                            />
                        </Grid.Column>
                    )}
                    {fieldValue?.trim() && (
                        <Grid.Column>
                            <DropDown
                                id={`MU_OPTIONS`}
                                label='OPTIONS'
                                className='field-bg dropdown100'
                                labelClass='text-none'
                                direction='left'
                                clearable
                                data={MU_OPTIONS}
                                value={massUpdateValue}
                                isDisabled={!fieldValue?.trim()}
                                name='massUpdateValue'
                                onChange={onDropDownChange}
                            />
                        </Grid.Column>
                    )}
                    {(massUpdateValue == '1' || massUpdateValue == '3') && (
                        <Grid.Column id={massUpdateValue == '1' ? 'borderLeftNone' : ''}>
                            {massUpdateValue == '1' && (<MUInvoiceList
                                invoiceDataList={invoiceDataList}
                                updateInvoiceHeader={updateInvoiceHeader}
                            />)}
                            {massUpdateValue == '3' && (
                                <DropDown
                                    id={`invoiceDataList`}
                                    label='INVOICE'
                                    className='field-bg dropdown100'
                                    labelClass='text-none'
                                    direction='left'
                                    clearable
                                    data={invoiceDataList}
                                    value={Array.isArray(invoiceValues) ? '' : invoiceValues?.value}
                                    disabled={!massUpdateValue?.trim()}
                                    name='invoiceValues'
                                    onChange={onDropDownChange}
                                />
                            )}
                        </Grid.Column>
                    )}

                    {(massUpdateValue == '3' && invoiceValues?.value) && (
                        <Grid.Column id='borderLeftNone'>
                            <MUMerchList
                                merchDataList={merchDataList}
                                updateMerchandiseItem={updateMerchandiseItem}
                            />
                        </Grid.Column>
                    )}
                </Grid.Row>
            </Grid>
            <div style={{ textAlign: 'right', marginTop: '10px' }}>
                {displayApplyButton && (
                    <Button
                        size="mini"
                        className='sv todo-button'
                        style={{ margin: '0px' }}
                        onClick={() => applyMassUpdate()}
                    >
                        {translate("APPLY_MASS_UPDATE")}
                    </Button>
                )}
            </div>
        </Message>
    )
}

export default MassUpdate